import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const deviceGroupConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default deviceGroupConfig;
